module.exports = __webpack_public_path__ + "static/img/App_badge_downloadAndroid.87acc60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/App_badge_downloadAndroid.png
// module id = 7Rns
// module chunks = 1